import React, { Component } from "react";
import PropTypes from "prop-types";
import Paginator from "@components/paginator";
import { getComments } from "@shared/apis/cprod";
import Comment from "./comment/index";
import CommentsInfo from "./comments-info/index";
import CommentsExt from "./comments-ext/index";

const PAGE_SIZE = 3;

class CommentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: {
        total: 0,
        list: [],
      },
    };
  }

  componentDidMount() {
    this.queryComments(1, true);
  }

  queryComments(pageNow, isInit) {
    getComments({
      productId: this.props.productId,
      pageNow,
      pageSize: PAGE_SIZE,
    }).then(res => {
      this.setState({
        comments: res.body.data,
        pageNow,
      });
      if (!isInit) {
        document.getElementById("productCommentsList").scrollIntoView();
      }
    });
  }

  render() {
    const { commentsInfo, product } = this.props;
    const { comments, pageNow } = this.state;
    const totalPage = Math.ceil(comments.total / PAGE_SIZE);
    if (commentsInfo.count > 0) {
      return (
        <div id="productCommentsList">
          <CommentsInfo commentsInfo={commentsInfo} />
          <ul className="comment-grid clearfix list-unstyled">
            {comments.list.map(item => (
              <li className="comment-grid__item" key={`comment-${item.commentId}`}>
                <hr />
                <Comment comment={item} />
              </li>
            ))}
          </ul>
          {totalPage > 1 ? (
            <Paginator
              pageNow={+pageNow}
              totalPage={totalPage}
              onPageChange={page => {
                this.queryComments(page);
              }}
            />
          ) : (
            ""
          )}
        </div>
      );
    }
    if (product.extOverallRating) {
      return <CommentsExt product={product} />;
    }
    return <noscript />;
  }
}

CommentList.propTypes = {
  productId: PropTypes.number.isRequired,
  product: PropTypes.object.isRequired,
  commentsInfo: PropTypes.object,
};

CommentList.defaultProps = {
  commentsInfo: {
    count: 0,
  },
};

export default CommentList;
